/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createAdministrator = /* GraphQL */ `mutation CreateAdministrator(
  $input: CreateAdministratorInput!
  $condition: ModelAdministratorConditionInput
) {
  createAdministrator(input: $input, condition: $condition) {
    id
    username
    status
    role
    firstName
    middleName
    lastName
    email
    phone
    address
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdministratorMutationVariables,
  APITypes.CreateAdministratorMutation
>;
export const updateAdministrator = /* GraphQL */ `mutation UpdateAdministrator(
  $input: UpdateAdministratorInput!
  $condition: ModelAdministratorConditionInput
) {
  updateAdministrator(input: $input, condition: $condition) {
    id
    username
    status
    role
    firstName
    middleName
    lastName
    email
    phone
    address
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAdministratorMutationVariables,
  APITypes.UpdateAdministratorMutation
>;
export const deleteAdministrator = /* GraphQL */ `mutation DeleteAdministrator(
  $input: DeleteAdministratorInput!
  $condition: ModelAdministratorConditionInput
) {
  deleteAdministrator(input: $input, condition: $condition) {
    id
    username
    status
    role
    firstName
    middleName
    lastName
    email
    phone
    address
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAdministratorMutationVariables,
  APITypes.DeleteAdministratorMutation
>;
export const createAdministratorApprovers = /* GraphQL */ `mutation CreateAdministratorApprovers(
  $input: CreateAdministratorApproversInput!
  $condition: ModelAdministratorApproversConditionInput
) {
  createAdministratorApprovers(input: $input, condition: $condition) {
    id
    userID
    editor
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdministratorApproversMutationVariables,
  APITypes.CreateAdministratorApproversMutation
>;
export const updateAdministratorApprovers = /* GraphQL */ `mutation UpdateAdministratorApprovers(
  $input: UpdateAdministratorApproversInput!
  $condition: ModelAdministratorApproversConditionInput
) {
  updateAdministratorApprovers(input: $input, condition: $condition) {
    id
    userID
    editor
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAdministratorApproversMutationVariables,
  APITypes.UpdateAdministratorApproversMutation
>;
export const deleteAdministratorApprovers = /* GraphQL */ `mutation DeleteAdministratorApprovers(
  $input: DeleteAdministratorApproversInput!
  $condition: ModelAdministratorApproversConditionInput
) {
  deleteAdministratorApprovers(input: $input, condition: $condition) {
    id
    userID
    editor
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAdministratorApproversMutationVariables,
  APITypes.DeleteAdministratorApproversMutation
>;
export const createAffiliate = /* GraphQL */ `mutation CreateAffiliate(
  $input: CreateAffiliateInput!
  $condition: ModelAffiliateConditionInput
) {
  createAffiliate(input: $input, condition: $condition) {
    id
    firstName
    middleName
    lastName
    email
    phone
    company
    address
    notes
    code
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAffiliateMutationVariables,
  APITypes.CreateAffiliateMutation
>;
export const updateAffiliate = /* GraphQL */ `mutation UpdateAffiliate(
  $input: UpdateAffiliateInput!
  $condition: ModelAffiliateConditionInput
) {
  updateAffiliate(input: $input, condition: $condition) {
    id
    firstName
    middleName
    lastName
    email
    phone
    company
    address
    notes
    code
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAffiliateMutationVariables,
  APITypes.UpdateAffiliateMutation
>;
export const deleteAffiliate = /* GraphQL */ `mutation DeleteAffiliate(
  $input: DeleteAffiliateInput!
  $condition: ModelAffiliateConditionInput
) {
  deleteAffiliate(input: $input, condition: $condition) {
    id
    firstName
    middleName
    lastName
    email
    phone
    company
    address
    notes
    code
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAffiliateMutationVariables,
  APITypes.DeleteAffiliateMutation
>;
export const createAffiliateEarning = /* GraphQL */ `mutation CreateAffiliateEarning(
  $input: CreateAffiliateEarningInput!
  $condition: ModelAffiliateEarningConditionInput
) {
  createAffiliateEarning(input: $input, condition: $condition) {
    id
    affiliateID
    linkID
    milestoneKey
    amountCents
    status
    payoutID
    idempotencyKey
    occurredAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAffiliateEarningMutationVariables,
  APITypes.CreateAffiliateEarningMutation
>;
export const updateAffiliateEarning = /* GraphQL */ `mutation UpdateAffiliateEarning(
  $input: UpdateAffiliateEarningInput!
  $condition: ModelAffiliateEarningConditionInput
) {
  updateAffiliateEarning(input: $input, condition: $condition) {
    id
    affiliateID
    linkID
    milestoneKey
    amountCents
    status
    payoutID
    idempotencyKey
    occurredAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAffiliateEarningMutationVariables,
  APITypes.UpdateAffiliateEarningMutation
>;
export const deleteAffiliateEarning = /* GraphQL */ `mutation DeleteAffiliateEarning(
  $input: DeleteAffiliateEarningInput!
  $condition: ModelAffiliateEarningConditionInput
) {
  deleteAffiliateEarning(input: $input, condition: $condition) {
    id
    affiliateID
    linkID
    milestoneKey
    amountCents
    status
    payoutID
    idempotencyKey
    occurredAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAffiliateEarningMutationVariables,
  APITypes.DeleteAffiliateEarningMutation
>;
export const createAffiliateLink = /* GraphQL */ `mutation CreateAffiliateLink(
  $input: CreateAffiliateLinkInput!
  $condition: ModelAffiliateLinkConditionInput
) {
  createAffiliateLink(input: $input, condition: $condition) {
    id
    ownerID
    ownerType
    affiliateID
    affiliateCode
    attributedAt
    migratedToOrganizationID
    createdByUserID
    milestones
    unitCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAffiliateLinkMutationVariables,
  APITypes.CreateAffiliateLinkMutation
>;
export const updateAffiliateLink = /* GraphQL */ `mutation UpdateAffiliateLink(
  $input: UpdateAffiliateLinkInput!
  $condition: ModelAffiliateLinkConditionInput
) {
  updateAffiliateLink(input: $input, condition: $condition) {
    id
    ownerID
    ownerType
    affiliateID
    affiliateCode
    attributedAt
    migratedToOrganizationID
    createdByUserID
    milestones
    unitCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAffiliateLinkMutationVariables,
  APITypes.UpdateAffiliateLinkMutation
>;
export const deleteAffiliateLink = /* GraphQL */ `mutation DeleteAffiliateLink(
  $input: DeleteAffiliateLinkInput!
  $condition: ModelAffiliateLinkConditionInput
) {
  deleteAffiliateLink(input: $input, condition: $condition) {
    id
    ownerID
    ownerType
    affiliateID
    affiliateCode
    attributedAt
    migratedToOrganizationID
    createdByUserID
    milestones
    unitCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAffiliateLinkMutationVariables,
  APITypes.DeleteAffiliateLinkMutation
>;
export const createAffiliateMilestoneRate = /* GraphQL */ `mutation CreateAffiliateMilestoneRate(
  $input: CreateAffiliateMilestoneRateInput!
  $condition: ModelAffiliateMilestoneRateConditionInput
) {
  createAffiliateMilestoneRate(input: $input, condition: $condition) {
    id
    milestoneKey
    amountCents
    affiliateID
    currency
    effectiveFrom
    effectiveTo
    isActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAffiliateMilestoneRateMutationVariables,
  APITypes.CreateAffiliateMilestoneRateMutation
>;
export const updateAffiliateMilestoneRate = /* GraphQL */ `mutation UpdateAffiliateMilestoneRate(
  $input: UpdateAffiliateMilestoneRateInput!
  $condition: ModelAffiliateMilestoneRateConditionInput
) {
  updateAffiliateMilestoneRate(input: $input, condition: $condition) {
    id
    milestoneKey
    amountCents
    affiliateID
    currency
    effectiveFrom
    effectiveTo
    isActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAffiliateMilestoneRateMutationVariables,
  APITypes.UpdateAffiliateMilestoneRateMutation
>;
export const deleteAffiliateMilestoneRate = /* GraphQL */ `mutation DeleteAffiliateMilestoneRate(
  $input: DeleteAffiliateMilestoneRateInput!
  $condition: ModelAffiliateMilestoneRateConditionInput
) {
  deleteAffiliateMilestoneRate(input: $input, condition: $condition) {
    id
    milestoneKey
    amountCents
    affiliateID
    currency
    effectiveFrom
    effectiveTo
    isActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAffiliateMilestoneRateMutationVariables,
  APITypes.DeleteAffiliateMilestoneRateMutation
>;
export const createAffiliatePayout = /* GraphQL */ `mutation CreateAffiliatePayout(
  $input: CreateAffiliatePayoutInput!
  $condition: ModelAffiliatePayoutConditionInput
) {
  createAffiliatePayout(input: $input, condition: $condition) {
    id
    affiliateID
    status
    grossCents
    generatedAt
    paidAt
    paymentRef
    notes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAffiliatePayoutMutationVariables,
  APITypes.CreateAffiliatePayoutMutation
>;
export const updateAffiliatePayout = /* GraphQL */ `mutation UpdateAffiliatePayout(
  $input: UpdateAffiliatePayoutInput!
  $condition: ModelAffiliatePayoutConditionInput
) {
  updateAffiliatePayout(input: $input, condition: $condition) {
    id
    affiliateID
    status
    grossCents
    generatedAt
    paidAt
    paymentRef
    notes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAffiliatePayoutMutationVariables,
  APITypes.UpdateAffiliatePayoutMutation
>;
export const deleteAffiliatePayout = /* GraphQL */ `mutation DeleteAffiliatePayout(
  $input: DeleteAffiliatePayoutInput!
  $condition: ModelAffiliatePayoutConditionInput
) {
  deleteAffiliatePayout(input: $input, condition: $condition) {
    id
    affiliateID
    status
    grossCents
    generatedAt
    paidAt
    paymentRef
    notes
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAffiliatePayoutMutationVariables,
  APITypes.DeleteAffiliatePayoutMutation
>;
export const createAffiliateVisit = /* GraphQL */ `mutation CreateAffiliateVisit(
  $input: CreateAffiliateVisitInput!
  $condition: ModelAffiliateVisitConditionInput
) {
  createAffiliateVisit(input: $input, condition: $condition) {
    id
    affiliateID
    affiliateCode
    visitedAt
    path
    userAgent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAffiliateVisitMutationVariables,
  APITypes.CreateAffiliateVisitMutation
>;
export const updateAffiliateVisit = /* GraphQL */ `mutation UpdateAffiliateVisit(
  $input: UpdateAffiliateVisitInput!
  $condition: ModelAffiliateVisitConditionInput
) {
  updateAffiliateVisit(input: $input, condition: $condition) {
    id
    affiliateID
    affiliateCode
    visitedAt
    path
    userAgent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAffiliateVisitMutationVariables,
  APITypes.UpdateAffiliateVisitMutation
>;
export const deleteAffiliateVisit = /* GraphQL */ `mutation DeleteAffiliateVisit(
  $input: DeleteAffiliateVisitInput!
  $condition: ModelAffiliateVisitConditionInput
) {
  deleteAffiliateVisit(input: $input, condition: $condition) {
    id
    affiliateID
    affiliateCode
    visitedAt
    path
    userAgent
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAffiliateVisitMutationVariables,
  APITypes.DeleteAffiliateVisitMutation
>;
export const createAmenity = /* GraphQL */ `mutation CreateAmenity(
  $input: CreateAmenityInput!
  $condition: ModelAmenityConditionInput
) {
  createAmenity(input: $input, condition: $condition) {
    id
    propertyID
    name
    userID
    ownerID
    ownerType
    reservationRule {
      policy
      userID
      ownerID
      ownerType
      requiresApproval
      maxDuration
      minDuration
      furthestTime
      closestTime
      maxPartySize
      maxRequests
      __typename
    }
    description
    rules
    availability
    geolocation
    locationDescription
    buildingID
    images
    lockUnixTTL
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAmenityMutationVariables,
  APITypes.CreateAmenityMutation
>;
export const updateAmenity = /* GraphQL */ `mutation UpdateAmenity(
  $input: UpdateAmenityInput!
  $condition: ModelAmenityConditionInput
) {
  updateAmenity(input: $input, condition: $condition) {
    id
    propertyID
    name
    userID
    ownerID
    ownerType
    reservationRule {
      policy
      userID
      ownerID
      ownerType
      requiresApproval
      maxDuration
      minDuration
      furthestTime
      closestTime
      maxPartySize
      maxRequests
      __typename
    }
    description
    rules
    availability
    geolocation
    locationDescription
    buildingID
    images
    lockUnixTTL
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAmenityMutationVariables,
  APITypes.UpdateAmenityMutation
>;
export const deleteAmenity = /* GraphQL */ `mutation DeleteAmenity(
  $input: DeleteAmenityInput!
  $condition: ModelAmenityConditionInput
) {
  deleteAmenity(input: $input, condition: $condition) {
    id
    propertyID
    name
    userID
    ownerID
    ownerType
    reservationRule {
      policy
      userID
      ownerID
      ownerType
      requiresApproval
      maxDuration
      minDuration
      furthestTime
      closestTime
      maxPartySize
      maxRequests
      __typename
    }
    description
    rules
    availability
    geolocation
    locationDescription
    buildingID
    images
    lockUnixTTL
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAmenityMutationVariables,
  APITypes.DeleteAmenityMutation
>;
export const createAmenityReservation = /* GraphQL */ `mutation CreateAmenityReservation(
  $input: CreateAmenityReservationInput!
  $condition: ModelAmenityReservationConditionInput
) {
  createAmenityReservation(input: $input, condition: $condition) {
    id
    amenityID
    tenantID
    startDate
    userID
    ownerID
    ownerType
    details
    status
    statusReason
    endDate
    reviewer
    partySize
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAmenityReservationMutationVariables,
  APITypes.CreateAmenityReservationMutation
>;
export const updateAmenityReservation = /* GraphQL */ `mutation UpdateAmenityReservation(
  $input: UpdateAmenityReservationInput!
  $condition: ModelAmenityReservationConditionInput
) {
  updateAmenityReservation(input: $input, condition: $condition) {
    id
    amenityID
    tenantID
    startDate
    userID
    ownerID
    ownerType
    details
    status
    statusReason
    endDate
    reviewer
    partySize
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAmenityReservationMutationVariables,
  APITypes.UpdateAmenityReservationMutation
>;
export const deleteAmenityReservation = /* GraphQL */ `mutation DeleteAmenityReservation(
  $input: DeleteAmenityReservationInput!
  $condition: ModelAmenityReservationConditionInput
) {
  deleteAmenityReservation(input: $input, condition: $condition) {
    id
    amenityID
    tenantID
    startDate
    userID
    ownerID
    ownerType
    details
    status
    statusReason
    endDate
    reviewer
    partySize
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAmenityReservationMutationVariables,
  APITypes.DeleteAmenityReservationMutation
>;
export const createApplication = /* GraphQL */ `mutation CreateApplication(
  $input: CreateApplicationInput!
  $condition: ModelApplicationConditionInput
) {
  createApplication(input: $input, condition: $condition) {
    id
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    moveInDatePreference
    rentPaymentPreference
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateApplicationMutationVariables,
  APITypes.CreateApplicationMutation
>;
export const updateApplication = /* GraphQL */ `mutation UpdateApplication(
  $input: UpdateApplicationInput!
  $condition: ModelApplicationConditionInput
) {
  updateApplication(input: $input, condition: $condition) {
    id
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    moveInDatePreference
    rentPaymentPreference
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateApplicationMutationVariables,
  APITypes.UpdateApplicationMutation
>;
export const deleteApplication = /* GraphQL */ `mutation DeleteApplication(
  $input: DeleteApplicationInput!
  $condition: ModelApplicationConditionInput
) {
  deleteApplication(input: $input, condition: $condition) {
    id
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    moveInDatePreference
    rentPaymentPreference
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteApplicationMutationVariables,
  APITypes.DeleteApplicationMutation
>;
export const createBackgroundCheck = /* GraphQL */ `mutation CreateBackgroundCheck(
  $input: CreateBackgroundCheckInput!
  $condition: ModelBackgroundCheckConditionInput
) {
  createBackgroundCheck(input: $input, condition: $condition) {
    id
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBackgroundCheckMutationVariables,
  APITypes.CreateBackgroundCheckMutation
>;
export const updateBackgroundCheck = /* GraphQL */ `mutation UpdateBackgroundCheck(
  $input: UpdateBackgroundCheckInput!
  $condition: ModelBackgroundCheckConditionInput
) {
  updateBackgroundCheck(input: $input, condition: $condition) {
    id
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBackgroundCheckMutationVariables,
  APITypes.UpdateBackgroundCheckMutation
>;
export const deleteBackgroundCheck = /* GraphQL */ `mutation DeleteBackgroundCheck(
  $input: DeleteBackgroundCheckInput!
  $condition: ModelBackgroundCheckConditionInput
) {
  deleteBackgroundCheck(input: $input, condition: $condition) {
    id
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBackgroundCheckMutationVariables,
  APITypes.DeleteBackgroundCheckMutation
>;
export const createBuilding = /* GraphQL */ `mutation CreateBuilding(
  $input: CreateBuildingInput!
  $condition: ModelBuildingConditionInput
) {
  createBuilding(input: $input, condition: $condition) {
    id
    status
    propertyID
    name
    userID
    ownerID
    ownerType
    description
    rent
    price
    numBedroom
    numBathroom
    actualRentPaymentDate
    size
    street
    type
    contact
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBuildingMutationVariables,
  APITypes.CreateBuildingMutation
>;
export const updateBuilding = /* GraphQL */ `mutation UpdateBuilding(
  $input: UpdateBuildingInput!
  $condition: ModelBuildingConditionInput
) {
  updateBuilding(input: $input, condition: $condition) {
    id
    status
    propertyID
    name
    userID
    ownerID
    ownerType
    description
    rent
    price
    numBedroom
    numBathroom
    actualRentPaymentDate
    size
    street
    type
    contact
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBuildingMutationVariables,
  APITypes.UpdateBuildingMutation
>;
export const deleteBuilding = /* GraphQL */ `mutation DeleteBuilding(
  $input: DeleteBuildingInput!
  $condition: ModelBuildingConditionInput
) {
  deleteBuilding(input: $input, condition: $condition) {
    id
    status
    propertyID
    name
    userID
    ownerID
    ownerType
    description
    rent
    price
    numBedroom
    numBathroom
    actualRentPaymentDate
    size
    street
    type
    contact
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBuildingMutationVariables,
  APITypes.DeleteBuildingMutation
>;
export const createCharges = /* GraphQL */ `mutation CreateCharges(
  $input: CreateChargesInput!
  $condition: ModelChargesConditionInput
) {
  createCharges(input: $input, condition: $condition) {
    id
    type
    isRevenue
    userID
    ownerID
    ownerType
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChargesMutationVariables,
  APITypes.CreateChargesMutation
>;
export const updateCharges = /* GraphQL */ `mutation UpdateCharges(
  $input: UpdateChargesInput!
  $condition: ModelChargesConditionInput
) {
  updateCharges(input: $input, condition: $condition) {
    id
    type
    isRevenue
    userID
    ownerID
    ownerType
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChargesMutationVariables,
  APITypes.UpdateChargesMutation
>;
export const deleteCharges = /* GraphQL */ `mutation DeleteCharges(
  $input: DeleteChargesInput!
  $condition: ModelChargesConditionInput
) {
  deleteCharges(input: $input, condition: $condition) {
    id
    type
    isRevenue
    userID
    ownerID
    ownerType
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChargesMutationVariables,
  APITypes.DeleteChargesMutation
>;
export const createComments = /* GraphQL */ `mutation CreateComments(
  $input: CreateCommentsInput!
  $condition: ModelCommentsConditionInput
) {
  createComments(input: $input, condition: $condition) {
    id
    commenter
    text
    userID
    ownerID
    ownerType
    createdDate
    parentID
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCommentsMutationVariables,
  APITypes.CreateCommentsMutation
>;
export const updateComments = /* GraphQL */ `mutation UpdateComments(
  $input: UpdateCommentsInput!
  $condition: ModelCommentsConditionInput
) {
  updateComments(input: $input, condition: $condition) {
    id
    commenter
    text
    userID
    ownerID
    ownerType
    createdDate
    parentID
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCommentsMutationVariables,
  APITypes.UpdateCommentsMutation
>;
export const deleteComments = /* GraphQL */ `mutation DeleteComments(
  $input: DeleteCommentsInput!
  $condition: ModelCommentsConditionInput
) {
  deleteComments(input: $input, condition: $condition) {
    id
    commenter
    text
    userID
    ownerID
    ownerType
    createdDate
    parentID
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCommentsMutationVariables,
  APITypes.DeleteCommentsMutation
>;
export const createEntityField = /* GraphQL */ `mutation CreateEntityField(
  $input: CreateEntityFieldInput!
  $condition: ModelEntityFieldConditionInput
) {
  createEntityField(input: $input, condition: $condition) {
    id
    entityID
    entityType
    name
    type
    userID
    ownerID
    ownerType
    value
    date
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEntityFieldMutationVariables,
  APITypes.CreateEntityFieldMutation
>;
export const updateEntityField = /* GraphQL */ `mutation UpdateEntityField(
  $input: UpdateEntityFieldInput!
  $condition: ModelEntityFieldConditionInput
) {
  updateEntityField(input: $input, condition: $condition) {
    id
    entityID
    entityType
    name
    type
    userID
    ownerID
    ownerType
    value
    date
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEntityFieldMutationVariables,
  APITypes.UpdateEntityFieldMutation
>;
export const deleteEntityField = /* GraphQL */ `mutation DeleteEntityField(
  $input: DeleteEntityFieldInput!
  $condition: ModelEntityFieldConditionInput
) {
  deleteEntityField(input: $input, condition: $condition) {
    id
    entityID
    entityType
    name
    type
    userID
    ownerID
    ownerType
    value
    date
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEntityFieldMutationVariables,
  APITypes.DeleteEntityFieldMutation
>;
export const createEvent = /* GraphQL */ `mutation CreateEvent(
  $input: CreateEventInput!
  $condition: ModelEventConditionInput
) {
  createEvent(input: $input, condition: $condition) {
    id
    entityType
    entityID
    ownerID
    ownerType
    name
    date
    type
    comment
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventMutationVariables,
  APITypes.CreateEventMutation
>;
export const updateEvent = /* GraphQL */ `mutation UpdateEvent(
  $input: UpdateEventInput!
  $condition: ModelEventConditionInput
) {
  updateEvent(input: $input, condition: $condition) {
    id
    entityType
    entityID
    ownerID
    ownerType
    name
    date
    type
    comment
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventMutationVariables,
  APITypes.UpdateEventMutation
>;
export const deleteEvent = /* GraphQL */ `mutation DeleteEvent(
  $input: DeleteEventInput!
  $condition: ModelEventConditionInput
) {
  deleteEvent(input: $input, condition: $condition) {
    id
    entityType
    entityID
    ownerID
    ownerType
    name
    date
    type
    comment
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventMutationVariables,
  APITypes.DeleteEventMutation
>;
export const createFavorite = /* GraphQL */ `mutation CreateFavorite(
  $input: CreateFavoriteInput!
  $condition: ModelFavoriteConditionInput
) {
  createFavorite(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    favType
    favID
    image
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFavoriteMutationVariables,
  APITypes.CreateFavoriteMutation
>;
export const updateFavorite = /* GraphQL */ `mutation UpdateFavorite(
  $input: UpdateFavoriteInput!
  $condition: ModelFavoriteConditionInput
) {
  updateFavorite(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    favType
    favID
    image
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFavoriteMutationVariables,
  APITypes.UpdateFavoriteMutation
>;
export const deleteFavorite = /* GraphQL */ `mutation DeleteFavorite(
  $input: DeleteFavoriteInput!
  $condition: ModelFavoriteConditionInput
) {
  deleteFavorite(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    favType
    favID
    image
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFavoriteMutationVariables,
  APITypes.DeleteFavoriteMutation
>;
export const createFinanceLock = /* GraphQL */ `mutation CreateFinanceLock(
  $input: CreateFinanceLockInput!
  $condition: ModelFinanceLockConditionInput
) {
  createFinanceLock(input: $input, condition: $condition) {
    id
    scope
    ownerID
    ownerType
    entityID
    entityType
    year
    month
    lockUnixTTL
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFinanceLockMutationVariables,
  APITypes.CreateFinanceLockMutation
>;
export const updateFinanceLock = /* GraphQL */ `mutation UpdateFinanceLock(
  $input: UpdateFinanceLockInput!
  $condition: ModelFinanceLockConditionInput
) {
  updateFinanceLock(input: $input, condition: $condition) {
    id
    scope
    ownerID
    ownerType
    entityID
    entityType
    year
    month
    lockUnixTTL
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFinanceLockMutationVariables,
  APITypes.UpdateFinanceLockMutation
>;
export const deleteFinanceLock = /* GraphQL */ `mutation DeleteFinanceLock(
  $input: DeleteFinanceLockInput!
  $condition: ModelFinanceLockConditionInput
) {
  deleteFinanceLock(input: $input, condition: $condition) {
    id
    scope
    ownerID
    ownerType
    entityID
    entityType
    year
    month
    lockUnixTTL
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFinanceLockMutationVariables,
  APITypes.DeleteFinanceLockMutation
>;
export const createJoinOrganizationRequest = /* GraphQL */ `mutation CreateJoinOrganizationRequest(
  $input: CreateJoinOrganizationRequestInput!
  $condition: ModelJoinOrganizationRequestConditionInput
) {
  createJoinOrganizationRequest(input: $input, condition: $condition) {
    id
    userID
    requestStatus
    organizationID
    requestPropertyTransfer
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateJoinOrganizationRequestMutationVariables,
  APITypes.CreateJoinOrganizationRequestMutation
>;
export const updateJoinOrganizationRequest = /* GraphQL */ `mutation UpdateJoinOrganizationRequest(
  $input: UpdateJoinOrganizationRequestInput!
  $condition: ModelJoinOrganizationRequestConditionInput
) {
  updateJoinOrganizationRequest(input: $input, condition: $condition) {
    id
    userID
    requestStatus
    organizationID
    requestPropertyTransfer
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateJoinOrganizationRequestMutationVariables,
  APITypes.UpdateJoinOrganizationRequestMutation
>;
export const deleteJoinOrganizationRequest = /* GraphQL */ `mutation DeleteJoinOrganizationRequest(
  $input: DeleteJoinOrganizationRequestInput!
  $condition: ModelJoinOrganizationRequestConditionInput
) {
  deleteJoinOrganizationRequest(input: $input, condition: $condition) {
    id
    userID
    requestStatus
    organizationID
    requestPropertyTransfer
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteJoinOrganizationRequestMutationVariables,
  APITypes.DeleteJoinOrganizationRequestMutation
>;
export const createLease = /* GraphQL */ `mutation CreateLease(
  $input: CreateLeaseInput!
  $condition: ModelLeaseConditionInput
) {
  createLease(input: $input, condition: $condition) {
    id
    entityType
    entityID
    type
    status
    userID
    ownerID
    ownerType
    tenantID
    startDate
    endDate
    markedDate
    extraOccupants
    applicationID
    backgroundCheckID
    offerID
    moveInID
    moveOutID
    nextLeaseID
    prevLeaseID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLeaseMutationVariables,
  APITypes.CreateLeaseMutation
>;
export const updateLease = /* GraphQL */ `mutation UpdateLease(
  $input: UpdateLeaseInput!
  $condition: ModelLeaseConditionInput
) {
  updateLease(input: $input, condition: $condition) {
    id
    entityType
    entityID
    type
    status
    userID
    ownerID
    ownerType
    tenantID
    startDate
    endDate
    markedDate
    extraOccupants
    applicationID
    backgroundCheckID
    offerID
    moveInID
    moveOutID
    nextLeaseID
    prevLeaseID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLeaseMutationVariables,
  APITypes.UpdateLeaseMutation
>;
export const deleteLease = /* GraphQL */ `mutation DeleteLease(
  $input: DeleteLeaseInput!
  $condition: ModelLeaseConditionInput
) {
  deleteLease(input: $input, condition: $condition) {
    id
    entityType
    entityID
    type
    status
    userID
    ownerID
    ownerType
    tenantID
    startDate
    endDate
    markedDate
    extraOccupants
    applicationID
    backgroundCheckID
    offerID
    moveInID
    moveOutID
    nextLeaseID
    prevLeaseID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLeaseMutationVariables,
  APITypes.DeleteLeaseMutation
>;
export const createMessage = /* GraphQL */ `mutation CreateMessage(
  $input: CreateMessageInput!
  $condition: ModelMessageConditionInput
) {
  createMessage(input: $input, condition: $condition) {
    id
    title
    content
    userID
    ownerID
    ownerType
    senderID
    senderName
    receiverID
    receiverName
    messageTitle
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessageMutationVariables,
  APITypes.CreateMessageMutation
>;
export const updateMessage = /* GraphQL */ `mutation UpdateMessage(
  $input: UpdateMessageInput!
  $condition: ModelMessageConditionInput
) {
  updateMessage(input: $input, condition: $condition) {
    id
    title
    content
    userID
    ownerID
    ownerType
    senderID
    senderName
    receiverID
    receiverName
    messageTitle
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessageMutationVariables,
  APITypes.UpdateMessageMutation
>;
export const deleteMessage = /* GraphQL */ `mutation DeleteMessage(
  $input: DeleteMessageInput!
  $condition: ModelMessageConditionInput
) {
  deleteMessage(input: $input, condition: $condition) {
    id
    title
    content
    userID
    ownerID
    ownerType
    senderID
    senderName
    receiverID
    receiverName
    messageTitle
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessageMutationVariables,
  APITypes.DeleteMessageMutation
>;
export const createMonthlyFinanceReport = /* GraphQL */ `mutation CreateMonthlyFinanceReport(
  $input: CreateMonthlyFinanceReportInput!
  $condition: ModelMonthlyFinanceReportConditionInput
) {
  createMonthlyFinanceReport(input: $input, condition: $condition) {
    id
    yearlyReportId
    month
    year
    userID
    ownerID
    ownerType
    entityID
    entityType
    income {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonthlyFinanceReportMutationVariables,
  APITypes.CreateMonthlyFinanceReportMutation
>;
export const updateMonthlyFinanceReport = /* GraphQL */ `mutation UpdateMonthlyFinanceReport(
  $input: UpdateMonthlyFinanceReportInput!
  $condition: ModelMonthlyFinanceReportConditionInput
) {
  updateMonthlyFinanceReport(input: $input, condition: $condition) {
    id
    yearlyReportId
    month
    year
    userID
    ownerID
    ownerType
    entityID
    entityType
    income {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMonthlyFinanceReportMutationVariables,
  APITypes.UpdateMonthlyFinanceReportMutation
>;
export const deleteMonthlyFinanceReport = /* GraphQL */ `mutation DeleteMonthlyFinanceReport(
  $input: DeleteMonthlyFinanceReportInput!
  $condition: ModelMonthlyFinanceReportConditionInput
) {
  deleteMonthlyFinanceReport(input: $input, condition: $condition) {
    id
    yearlyReportId
    month
    year
    userID
    ownerID
    ownerType
    entityID
    entityType
    income {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMonthlyFinanceReportMutationVariables,
  APITypes.DeleteMonthlyFinanceReportMutation
>;
export const createMonthlyStatusReport = /* GraphQL */ `mutation CreateMonthlyStatusReport(
  $input: CreateMonthlyStatusReportInput!
  $condition: ModelMonthlyStatusReportConditionInput
) {
  createMonthlyStatusReport(input: $input, condition: $condition) {
    id
    entityID
    entityType
    month
    year
    numOccupied
    numVacant
    numRenovation
    numUnits
    numBuildings
    numProperties
    numServiceRequests
    numAmenities
    numAmenityReservations
    expectedRent
    expectedStayRevenue
    aggregateIncome {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMonthlyStatusReportMutationVariables,
  APITypes.CreateMonthlyStatusReportMutation
>;
export const updateMonthlyStatusReport = /* GraphQL */ `mutation UpdateMonthlyStatusReport(
  $input: UpdateMonthlyStatusReportInput!
  $condition: ModelMonthlyStatusReportConditionInput
) {
  updateMonthlyStatusReport(input: $input, condition: $condition) {
    id
    entityID
    entityType
    month
    year
    numOccupied
    numVacant
    numRenovation
    numUnits
    numBuildings
    numProperties
    numServiceRequests
    numAmenities
    numAmenityReservations
    expectedRent
    expectedStayRevenue
    aggregateIncome {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMonthlyStatusReportMutationVariables,
  APITypes.UpdateMonthlyStatusReportMutation
>;
export const deleteMonthlyStatusReport = /* GraphQL */ `mutation DeleteMonthlyStatusReport(
  $input: DeleteMonthlyStatusReportInput!
  $condition: ModelMonthlyStatusReportConditionInput
) {
  deleteMonthlyStatusReport(input: $input, condition: $condition) {
    id
    entityID
    entityType
    month
    year
    numOccupied
    numVacant
    numRenovation
    numUnits
    numBuildings
    numProperties
    numServiceRequests
    numAmenities
    numAmenityReservations
    expectedRent
    expectedStayRevenue
    aggregateIncome {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMonthlyStatusReportMutationVariables,
  APITypes.DeleteMonthlyStatusReportMutation
>;
export const createMoveExam = /* GraphQL */ `mutation CreateMoveExam(
  $input: CreateMoveExamInput!
  $condition: ModelMoveExamConditionInput
) {
  createMoveExam(input: $input, condition: $condition) {
    id
    type
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMoveExamMutationVariables,
  APITypes.CreateMoveExamMutation
>;
export const updateMoveExam = /* GraphQL */ `mutation UpdateMoveExam(
  $input: UpdateMoveExamInput!
  $condition: ModelMoveExamConditionInput
) {
  updateMoveExam(input: $input, condition: $condition) {
    id
    type
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMoveExamMutationVariables,
  APITypes.UpdateMoveExamMutation
>;
export const deleteMoveExam = /* GraphQL */ `mutation DeleteMoveExam(
  $input: DeleteMoveExamInput!
  $condition: ModelMoveExamConditionInput
) {
  deleteMoveExam(input: $input, condition: $condition) {
    id
    type
    status
    userID
    ownerID
    ownerType
    startDate
    endDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMoveExamMutationVariables,
  APITypes.DeleteMoveExamMutation
>;
export const createOffer = /* GraphQL */ `mutation CreateOffer(
  $input: CreateOfferInput!
  $condition: ModelOfferConditionInput
) {
  createOffer(input: $input, condition: $condition) {
    id
    status
    rent
    userID
    ownerID
    ownerType
    startDate
    tenantSignDate
    landlordSignDate
    endDate
    rentCycle
    normalizedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOfferMutationVariables,
  APITypes.CreateOfferMutation
>;
export const updateOffer = /* GraphQL */ `mutation UpdateOffer(
  $input: UpdateOfferInput!
  $condition: ModelOfferConditionInput
) {
  updateOffer(input: $input, condition: $condition) {
    id
    status
    rent
    userID
    ownerID
    ownerType
    startDate
    tenantSignDate
    landlordSignDate
    endDate
    rentCycle
    normalizedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOfferMutationVariables,
  APITypes.UpdateOfferMutation
>;
export const deleteOffer = /* GraphQL */ `mutation DeleteOffer(
  $input: DeleteOfferInput!
  $condition: ModelOfferConditionInput
) {
  deleteOffer(input: $input, condition: $condition) {
    id
    status
    rent
    userID
    ownerID
    ownerType
    startDate
    tenantSignDate
    landlordSignDate
    endDate
    rentCycle
    normalizedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOfferMutationVariables,
  APITypes.DeleteOfferMutation
>;
export const createOrganization = /* GraphQL */ `mutation CreateOrganization(
  $input: CreateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  createOrganization(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrganizationMutationVariables,
  APITypes.CreateOrganizationMutation
>;
export const updateOrganization = /* GraphQL */ `mutation UpdateOrganization(
  $input: UpdateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  updateOrganization(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrganizationMutationVariables,
  APITypes.UpdateOrganizationMutation
>;
export const deleteOrganization = /* GraphQL */ `mutation DeleteOrganization(
  $input: DeleteOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  deleteOrganization(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrganizationMutationVariables,
  APITypes.DeleteOrganizationMutation
>;
export const createParcel = /* GraphQL */ `mutation CreateParcel(
  $input: CreateParcelInput!
  $condition: ModelParcelConditionInput
) {
  createParcel(input: $input, condition: $condition) {
    id
    propertyID
    status
    name
    description
    areaSize
    boundaryNote
    rent
    price
    userID
    ownerID
    ownerType
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateParcelMutationVariables,
  APITypes.CreateParcelMutation
>;
export const updateParcel = /* GraphQL */ `mutation UpdateParcel(
  $input: UpdateParcelInput!
  $condition: ModelParcelConditionInput
) {
  updateParcel(input: $input, condition: $condition) {
    id
    propertyID
    status
    name
    description
    areaSize
    boundaryNote
    rent
    price
    userID
    ownerID
    ownerType
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateParcelMutationVariables,
  APITypes.UpdateParcelMutation
>;
export const deleteParcel = /* GraphQL */ `mutation DeleteParcel(
  $input: DeleteParcelInput!
  $condition: ModelParcelConditionInput
) {
  deleteParcel(input: $input, condition: $condition) {
    id
    propertyID
    status
    name
    description
    areaSize
    boundaryNote
    rent
    price
    userID
    ownerID
    ownerType
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteParcelMutationVariables,
  APITypes.DeleteParcelMutation
>;
export const createPaymentReceipt = /* GraphQL */ `mutation CreatePaymentReceipt(
  $input: CreatePaymentReceiptInput!
  $condition: ModelPaymentReceiptConditionInput
) {
  createPaymentReceipt(input: $input, condition: $condition) {
    id
    transactionID
    status
    failureReason
    s3Key
    s3Keys
    ownerID
    ownerType
    signedByUserID
    signedByUserName
    generatedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePaymentReceiptMutationVariables,
  APITypes.CreatePaymentReceiptMutation
>;
export const updatePaymentReceipt = /* GraphQL */ `mutation UpdatePaymentReceipt(
  $input: UpdatePaymentReceiptInput!
  $condition: ModelPaymentReceiptConditionInput
) {
  updatePaymentReceipt(input: $input, condition: $condition) {
    id
    transactionID
    status
    failureReason
    s3Key
    s3Keys
    ownerID
    ownerType
    signedByUserID
    signedByUserName
    generatedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePaymentReceiptMutationVariables,
  APITypes.UpdatePaymentReceiptMutation
>;
export const deletePaymentReceipt = /* GraphQL */ `mutation DeletePaymentReceipt(
  $input: DeletePaymentReceiptInput!
  $condition: ModelPaymentReceiptConditionInput
) {
  deletePaymentReceipt(input: $input, condition: $condition) {
    id
    transactionID
    status
    failureReason
    s3Key
    s3Keys
    ownerID
    ownerType
    signedByUserID
    signedByUserName
    generatedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePaymentReceiptMutationVariables,
  APITypes.DeletePaymentReceiptMutation
>;
export const createProperty = /* GraphQL */ `mutation CreateProperty(
  $input: CreatePropertyInput!
  $condition: ModelPropertyConditionInput
) {
  createProperty(input: $input, condition: $condition) {
    id
    name
    userID
    ownerID
    ownerType
    description
    areaSize
    street
    city
    state
    country
    zipCode
    contact
    expectedRentPaymentDate
    poBox
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePropertyMutationVariables,
  APITypes.CreatePropertyMutation
>;
export const updateProperty = /* GraphQL */ `mutation UpdateProperty(
  $input: UpdatePropertyInput!
  $condition: ModelPropertyConditionInput
) {
  updateProperty(input: $input, condition: $condition) {
    id
    name
    userID
    ownerID
    ownerType
    description
    areaSize
    street
    city
    state
    country
    zipCode
    contact
    expectedRentPaymentDate
    poBox
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePropertyMutationVariables,
  APITypes.UpdatePropertyMutation
>;
export const deleteProperty = /* GraphQL */ `mutation DeleteProperty(
  $input: DeletePropertyInput!
  $condition: ModelPropertyConditionInput
) {
  deleteProperty(input: $input, condition: $condition) {
    id
    name
    userID
    ownerID
    ownerType
    description
    areaSize
    street
    city
    state
    country
    zipCode
    contact
    expectedRentPaymentDate
    poBox
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePropertyMutationVariables,
  APITypes.DeletePropertyMutation
>;
export const createResourceLifeAccessRight = /* GraphQL */ `mutation CreateResourceLifeAccessRight(
  $input: CreateResourceLifeAccessRightInput!
  $condition: ModelResourceLifeAccessRightConditionInput
) {
  createResourceLifeAccessRight(input: $input, condition: $condition) {
    id
    resourceType
    createAccessStatus
    createAccessApproverID
    createAccessApprovalDate
    deleteAccessStatus
    deleteAccessApproverID
    deleteAccessApprovalDate
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateResourceLifeAccessRightMutationVariables,
  APITypes.CreateResourceLifeAccessRightMutation
>;
export const updateResourceLifeAccessRight = /* GraphQL */ `mutation UpdateResourceLifeAccessRight(
  $input: UpdateResourceLifeAccessRightInput!
  $condition: ModelResourceLifeAccessRightConditionInput
) {
  updateResourceLifeAccessRight(input: $input, condition: $condition) {
    id
    resourceType
    createAccessStatus
    createAccessApproverID
    createAccessApprovalDate
    deleteAccessStatus
    deleteAccessApproverID
    deleteAccessApprovalDate
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateResourceLifeAccessRightMutationVariables,
  APITypes.UpdateResourceLifeAccessRightMutation
>;
export const deleteResourceLifeAccessRight = /* GraphQL */ `mutation DeleteResourceLifeAccessRight(
  $input: DeleteResourceLifeAccessRightInput!
  $condition: ModelResourceLifeAccessRightConditionInput
) {
  deleteResourceLifeAccessRight(input: $input, condition: $condition) {
    id
    resourceType
    createAccessStatus
    createAccessApproverID
    createAccessApprovalDate
    deleteAccessStatus
    deleteAccessApproverID
    deleteAccessApprovalDate
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteResourceLifeAccessRightMutationVariables,
  APITypes.DeleteResourceLifeAccessRightMutation
>;
export const createResourceUpdateAccessRight = /* GraphQL */ `mutation CreateResourceUpdateAccessRight(
  $input: CreateResourceUpdateAccessRightInput!
  $condition: ModelResourceUpdateAccessRightConditionInput
) {
  createResourceUpdateAccessRight(input: $input, condition: $condition) {
    id
    resourceType
    resourceID
    userID
    ownerID
    ownerType
    readAccessStatus
    readAccessApproverID
    readAccessApprovalDate
    writeAccessStatus
    writeAccessApproverID
    writeAccessApprovalDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateResourceUpdateAccessRightMutationVariables,
  APITypes.CreateResourceUpdateAccessRightMutation
>;
export const updateResourceUpdateAccessRight = /* GraphQL */ `mutation UpdateResourceUpdateAccessRight(
  $input: UpdateResourceUpdateAccessRightInput!
  $condition: ModelResourceUpdateAccessRightConditionInput
) {
  updateResourceUpdateAccessRight(input: $input, condition: $condition) {
    id
    resourceType
    resourceID
    userID
    ownerID
    ownerType
    readAccessStatus
    readAccessApproverID
    readAccessApprovalDate
    writeAccessStatus
    writeAccessApproverID
    writeAccessApprovalDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateResourceUpdateAccessRightMutationVariables,
  APITypes.UpdateResourceUpdateAccessRightMutation
>;
export const deleteResourceUpdateAccessRight = /* GraphQL */ `mutation DeleteResourceUpdateAccessRight(
  $input: DeleteResourceUpdateAccessRightInput!
  $condition: ModelResourceUpdateAccessRightConditionInput
) {
  deleteResourceUpdateAccessRight(input: $input, condition: $condition) {
    id
    resourceType
    resourceID
    userID
    ownerID
    ownerType
    readAccessStatus
    readAccessApproverID
    readAccessApprovalDate
    writeAccessStatus
    writeAccessApproverID
    writeAccessApprovalDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteResourceUpdateAccessRightMutationVariables,
  APITypes.DeleteResourceUpdateAccessRightMutation
>;
export const createServiceRequest = /* GraphQL */ `mutation CreateServiceRequest(
  $input: CreateServiceRequestInput!
  $condition: ModelServiceRequestConditionInput
) {
  createServiceRequest(input: $input, condition: $condition) {
    id
    entityID
    entityType
    creatorID
    description
    title
    type
    isUpgrade
    status
    emergency
    userID
    ownerID
    ownerType
    creatorName
    handlerID
    handlerName
    watcherID
    watcherName
    tenantID
    tenantName
    contractor
    dateCreated
    dateUpdated
    estimatedCost
    finalCost
    images
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateServiceRequestMutationVariables,
  APITypes.CreateServiceRequestMutation
>;
export const updateServiceRequest = /* GraphQL */ `mutation UpdateServiceRequest(
  $input: UpdateServiceRequestInput!
  $condition: ModelServiceRequestConditionInput
) {
  updateServiceRequest(input: $input, condition: $condition) {
    id
    entityID
    entityType
    creatorID
    description
    title
    type
    isUpgrade
    status
    emergency
    userID
    ownerID
    ownerType
    creatorName
    handlerID
    handlerName
    watcherID
    watcherName
    tenantID
    tenantName
    contractor
    dateCreated
    dateUpdated
    estimatedCost
    finalCost
    images
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateServiceRequestMutationVariables,
  APITypes.UpdateServiceRequestMutation
>;
export const deleteServiceRequest = /* GraphQL */ `mutation DeleteServiceRequest(
  $input: DeleteServiceRequestInput!
  $condition: ModelServiceRequestConditionInput
) {
  deleteServiceRequest(input: $input, condition: $condition) {
    id
    entityID
    entityType
    creatorID
    description
    title
    type
    isUpgrade
    status
    emergency
    userID
    ownerID
    ownerType
    creatorName
    handlerID
    handlerName
    watcherID
    watcherName
    tenantID
    tenantName
    contractor
    dateCreated
    dateUpdated
    estimatedCost
    finalCost
    images
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteServiceRequestMutationVariables,
  APITypes.DeleteServiceRequestMutation
>;
export const createStay = /* GraphQL */ `mutation CreateStay(
  $input: CreateStayInput!
  $condition: ModelStayConditionInput
) {
  createStay(input: $input, condition: $condition) {
    id
    entityType
    entityID
    checkIn
    checkOut
    status
    tenantID
    nightlyRate
    totalAmount
    currency
    notes
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStayMutationVariables,
  APITypes.CreateStayMutation
>;
export const updateStay = /* GraphQL */ `mutation UpdateStay(
  $input: UpdateStayInput!
  $condition: ModelStayConditionInput
) {
  updateStay(input: $input, condition: $condition) {
    id
    entityType
    entityID
    checkIn
    checkOut
    status
    tenantID
    nightlyRate
    totalAmount
    currency
    notes
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStayMutationVariables,
  APITypes.UpdateStayMutation
>;
export const deleteStay = /* GraphQL */ `mutation DeleteStay(
  $input: DeleteStayInput!
  $condition: ModelStayConditionInput
) {
  deleteStay(input: $input, condition: $condition) {
    id
    entityType
    entityID
    checkIn
    checkOut
    status
    tenantID
    nightlyRate
    totalAmount
    currency
    notes
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStayMutationVariables,
  APITypes.DeleteStayMutation
>;
export const createStayRate = /* GraphQL */ `mutation CreateStayRate(
  $input: CreateStayRateInput!
  $condition: ModelStayRateConditionInput
) {
  createStayRate(input: $input, condition: $condition) {
    id
    entityType
    entityID
    nightlyRate
    weeklyRate
    minNights
    maxNights
    cleaningFee
    currency
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStayRateMutationVariables,
  APITypes.CreateStayRateMutation
>;
export const updateStayRate = /* GraphQL */ `mutation UpdateStayRate(
  $input: UpdateStayRateInput!
  $condition: ModelStayRateConditionInput
) {
  updateStayRate(input: $input, condition: $condition) {
    id
    entityType
    entityID
    nightlyRate
    weeklyRate
    minNights
    maxNights
    cleaningFee
    currency
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStayRateMutationVariables,
  APITypes.UpdateStayRateMutation
>;
export const deleteStayRate = /* GraphQL */ `mutation DeleteStayRate(
  $input: DeleteStayRateInput!
  $condition: ModelStayRateConditionInput
) {
  deleteStayRate(input: $input, condition: $condition) {
    id
    entityType
    entityID
    nightlyRate
    weeklyRate
    minNights
    maxNights
    cleaningFee
    currency
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStayRateMutationVariables,
  APITypes.DeleteStayRateMutation
>;
export const createStayAvailability = /* GraphQL */ `mutation CreateStayAvailability(
  $input: CreateStayAvailabilityInput!
  $condition: ModelStayAvailabilityConditionInput
) {
  createStayAvailability(input: $input, condition: $condition) {
    id
    entityType
    entityID
    start
    end
    reason
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStayAvailabilityMutationVariables,
  APITypes.CreateStayAvailabilityMutation
>;
export const updateStayAvailability = /* GraphQL */ `mutation UpdateStayAvailability(
  $input: UpdateStayAvailabilityInput!
  $condition: ModelStayAvailabilityConditionInput
) {
  updateStayAvailability(input: $input, condition: $condition) {
    id
    entityType
    entityID
    start
    end
    reason
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStayAvailabilityMutationVariables,
  APITypes.UpdateStayAvailabilityMutation
>;
export const deleteStayAvailability = /* GraphQL */ `mutation DeleteStayAvailability(
  $input: DeleteStayAvailabilityInput!
  $condition: ModelStayAvailabilityConditionInput
) {
  deleteStayAvailability(input: $input, condition: $condition) {
    id
    entityType
    entityID
    start
    end
    reason
    userID
    ownerID
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStayAvailabilityMutationVariables,
  APITypes.DeleteStayAvailabilityMutation
>;
export const createSubscriptionDiscount = /* GraphQL */ `mutation CreateSubscriptionDiscount(
  $input: CreateSubscriptionDiscountInput!
  $condition: ModelSubscriptionDiscountConditionInput
) {
  createSubscriptionDiscount(input: $input, condition: $condition) {
    id
    planID
    startDate
    endDate
    percentage
    isActive
    codeID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubscriptionDiscountMutationVariables,
  APITypes.CreateSubscriptionDiscountMutation
>;
export const updateSubscriptionDiscount = /* GraphQL */ `mutation UpdateSubscriptionDiscount(
  $input: UpdateSubscriptionDiscountInput!
  $condition: ModelSubscriptionDiscountConditionInput
) {
  updateSubscriptionDiscount(input: $input, condition: $condition) {
    id
    planID
    startDate
    endDate
    percentage
    isActive
    codeID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionDiscountMutationVariables,
  APITypes.UpdateSubscriptionDiscountMutation
>;
export const deleteSubscriptionDiscount = /* GraphQL */ `mutation DeleteSubscriptionDiscount(
  $input: DeleteSubscriptionDiscountInput!
  $condition: ModelSubscriptionDiscountConditionInput
) {
  deleteSubscriptionDiscount(input: $input, condition: $condition) {
    id
    planID
    startDate
    endDate
    percentage
    isActive
    codeID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubscriptionDiscountMutationVariables,
  APITypes.DeleteSubscriptionDiscountMutation
>;
export const createSubscriptionDiscountCode = /* GraphQL */ `mutation CreateSubscriptionDiscountCode(
  $input: CreateSubscriptionDiscountCodeInput!
  $condition: ModelSubscriptionDiscountCodeConditionInput
) {
  createSubscriptionDiscountCode(input: $input, condition: $condition) {
    id
    code
    userID
    usageCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubscriptionDiscountCodeMutationVariables,
  APITypes.CreateSubscriptionDiscountCodeMutation
>;
export const updateSubscriptionDiscountCode = /* GraphQL */ `mutation UpdateSubscriptionDiscountCode(
  $input: UpdateSubscriptionDiscountCodeInput!
  $condition: ModelSubscriptionDiscountCodeConditionInput
) {
  updateSubscriptionDiscountCode(input: $input, condition: $condition) {
    id
    code
    userID
    usageCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionDiscountCodeMutationVariables,
  APITypes.UpdateSubscriptionDiscountCodeMutation
>;
export const deleteSubscriptionDiscountCode = /* GraphQL */ `mutation DeleteSubscriptionDiscountCode(
  $input: DeleteSubscriptionDiscountCodeInput!
  $condition: ModelSubscriptionDiscountCodeConditionInput
) {
  deleteSubscriptionDiscountCode(input: $input, condition: $condition) {
    id
    code
    userID
    usageCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubscriptionDiscountCodeMutationVariables,
  APITypes.DeleteSubscriptionDiscountCodeMutation
>;
export const createSubscriptionLink = /* GraphQL */ `mutation CreateSubscriptionLink(
  $input: CreateSubscriptionLinkInput!
  $condition: ModelSubscriptionLinkConditionInput
) {
  createSubscriptionLink(input: $input, condition: $condition) {
    id
    userID
    planID
    startDate
    endDate
    renewalType
    autoRenewal
    nextPaymentAmount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubscriptionLinkMutationVariables,
  APITypes.CreateSubscriptionLinkMutation
>;
export const updateSubscriptionLink = /* GraphQL */ `mutation UpdateSubscriptionLink(
  $input: UpdateSubscriptionLinkInput!
  $condition: ModelSubscriptionLinkConditionInput
) {
  updateSubscriptionLink(input: $input, condition: $condition) {
    id
    userID
    planID
    startDate
    endDate
    renewalType
    autoRenewal
    nextPaymentAmount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionLinkMutationVariables,
  APITypes.UpdateSubscriptionLinkMutation
>;
export const deleteSubscriptionLink = /* GraphQL */ `mutation DeleteSubscriptionLink(
  $input: DeleteSubscriptionLinkInput!
  $condition: ModelSubscriptionLinkConditionInput
) {
  deleteSubscriptionLink(input: $input, condition: $condition) {
    id
    userID
    planID
    startDate
    endDate
    renewalType
    autoRenewal
    nextPaymentAmount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubscriptionLinkMutationVariables,
  APITypes.DeleteSubscriptionLinkMutation
>;
export const createSubscriptionPlan = /* GraphQL */ `mutation CreateSubscriptionPlan(
  $input: CreateSubscriptionPlanInput!
  $condition: ModelSubscriptionPlanConditionInput
) {
  createSubscriptionPlan(input: $input, condition: $condition) {
    id
    name
    description
    price
    isActive
    features
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubscriptionPlanMutationVariables,
  APITypes.CreateSubscriptionPlanMutation
>;
export const updateSubscriptionPlan = /* GraphQL */ `mutation UpdateSubscriptionPlan(
  $input: UpdateSubscriptionPlanInput!
  $condition: ModelSubscriptionPlanConditionInput
) {
  updateSubscriptionPlan(input: $input, condition: $condition) {
    id
    name
    description
    price
    isActive
    features
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionPlanMutationVariables,
  APITypes.UpdateSubscriptionPlanMutation
>;
export const deleteSubscriptionPlan = /* GraphQL */ `mutation DeleteSubscriptionPlan(
  $input: DeleteSubscriptionPlanInput!
  $condition: ModelSubscriptionPlanConditionInput
) {
  deleteSubscriptionPlan(input: $input, condition: $condition) {
    id
    name
    description
    price
    isActive
    features
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubscriptionPlanMutationVariables,
  APITypes.DeleteSubscriptionPlanMutation
>;
export const createTenant = /* GraphQL */ `mutation CreateTenant(
  $input: CreateTenantInput!
  $condition: ModelTenantConditionInput
) {
  createTenant(input: $input, condition: $condition) {
    id
    authUID
    username
    firstName
    middleName
    lastName
    userID
    ownerID
    ownerType
    status
    type
    phoneNumber
    jobTitle
    jobPhone
    jobEmail
    jobContactName
    income
    cimesCommitted
    jailTime
    lastArrest
    lastUpdated
    totalCredit
    employer
    email
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantMutationVariables,
  APITypes.CreateTenantMutation
>;
export const updateTenant = /* GraphQL */ `mutation UpdateTenant(
  $input: UpdateTenantInput!
  $condition: ModelTenantConditionInput
) {
  updateTenant(input: $input, condition: $condition) {
    id
    authUID
    username
    firstName
    middleName
    lastName
    userID
    ownerID
    ownerType
    status
    type
    phoneNumber
    jobTitle
    jobPhone
    jobEmail
    jobContactName
    income
    cimesCommitted
    jailTime
    lastArrest
    lastUpdated
    totalCredit
    employer
    email
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTenantMutationVariables,
  APITypes.UpdateTenantMutation
>;
export const deleteTenant = /* GraphQL */ `mutation DeleteTenant(
  $input: DeleteTenantInput!
  $condition: ModelTenantConditionInput
) {
  deleteTenant(input: $input, condition: $condition) {
    id
    authUID
    username
    firstName
    middleName
    lastName
    userID
    ownerID
    ownerType
    status
    type
    phoneNumber
    jobTitle
    jobPhone
    jobEmail
    jobContactName
    income
    cimesCommitted
    jailTime
    lastArrest
    lastUpdated
    totalCredit
    employer
    email
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTenantMutationVariables,
  APITypes.DeleteTenantMutation
>;
export const createTransaction = /* GraphQL */ `mutation CreateTransaction(
  $input: CreateTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  createTransaction(input: $input, condition: $condition) {
    id
    amount
    reason
    currency
    entityID
    entityType
    userID
    ownerID
    ownerType
    month
    year
    periodStart
    periodEnd
    tenantID
    managerID
    status
    dateSent
    dateReceived
    paymentMethod
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionMutationVariables,
  APITypes.CreateTransactionMutation
>;
export const updateTransaction = /* GraphQL */ `mutation UpdateTransaction(
  $input: UpdateTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  updateTransaction(input: $input, condition: $condition) {
    id
    amount
    reason
    currency
    entityID
    entityType
    userID
    ownerID
    ownerType
    month
    year
    periodStart
    periodEnd
    tenantID
    managerID
    status
    dateSent
    dateReceived
    paymentMethod
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransactionMutationVariables,
  APITypes.UpdateTransactionMutation
>;
export const deleteTransaction = /* GraphQL */ `mutation DeleteTransaction(
  $input: DeleteTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  deleteTransaction(input: $input, condition: $condition) {
    id
    amount
    reason
    currency
    entityID
    entityType
    userID
    ownerID
    ownerType
    month
    year
    periodStart
    periodEnd
    tenantID
    managerID
    status
    dateSent
    dateReceived
    paymentMethod
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTransactionMutationVariables,
  APITypes.DeleteTransactionMutation
>;
export const createUnitPlan = /* GraphQL */ `mutation CreateUnitPlan(
  $input: CreateUnitPlanInput!
  $condition: ModelUnitPlanConditionInput
) {
  createUnitPlan(input: $input, condition: $condition) {
    id
    propertyID
    name
    description
    numBedroom
    numBathroom
    size
    userID
    ownerID
    ownerType
    inUnitLaundry
    dishwasher
    airConditioning
    furnished
    balcony
    petFriendly
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUnitPlanMutationVariables,
  APITypes.CreateUnitPlanMutation
>;
export const updateUnitPlan = /* GraphQL */ `mutation UpdateUnitPlan(
  $input: UpdateUnitPlanInput!
  $condition: ModelUnitPlanConditionInput
) {
  updateUnitPlan(input: $input, condition: $condition) {
    id
    propertyID
    name
    description
    numBedroom
    numBathroom
    size
    userID
    ownerID
    ownerType
    inUnitLaundry
    dishwasher
    airConditioning
    furnished
    balcony
    petFriendly
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUnitPlanMutationVariables,
  APITypes.UpdateUnitPlanMutation
>;
export const deleteUnitPlan = /* GraphQL */ `mutation DeleteUnitPlan(
  $input: DeleteUnitPlanInput!
  $condition: ModelUnitPlanConditionInput
) {
  deleteUnitPlan(input: $input, condition: $condition) {
    id
    propertyID
    name
    description
    numBedroom
    numBathroom
    size
    userID
    ownerID
    ownerType
    inUnitLaundry
    dishwasher
    airConditioning
    furnished
    balcony
    petFriendly
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUnitPlanMutationVariables,
  APITypes.DeleteUnitPlanMutation
>;
export const createUnit = /* GraphQL */ `mutation CreateUnit(
  $input: CreateUnitInput!
  $condition: ModelUnitConditionInput
) {
  createUnit(input: $input, condition: $condition) {
    id
    status
    name
    rent
    price
    numBedroom
    numBathroom
    buildingID
    userID
    ownerID
    ownerType
    description
    availabilityDate
    actualRentPaymentDate
    activeLeaseID
    type
    unitPlanID
    size
    street
    deposit
    additionalFees
    feesDescription
    tenantID
    contact
    inUnitLaundry
    dishwasher
    airConditioning
    furnished
    balcony
    petFriendly
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUnitMutationVariables,
  APITypes.CreateUnitMutation
>;
export const updateUnit = /* GraphQL */ `mutation UpdateUnit(
  $input: UpdateUnitInput!
  $condition: ModelUnitConditionInput
) {
  updateUnit(input: $input, condition: $condition) {
    id
    status
    name
    rent
    price
    numBedroom
    numBathroom
    buildingID
    userID
    ownerID
    ownerType
    description
    availabilityDate
    actualRentPaymentDate
    activeLeaseID
    type
    unitPlanID
    size
    street
    deposit
    additionalFees
    feesDescription
    tenantID
    contact
    inUnitLaundry
    dishwasher
    airConditioning
    furnished
    balcony
    petFriendly
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUnitMutationVariables,
  APITypes.UpdateUnitMutation
>;
export const deleteUnit = /* GraphQL */ `mutation DeleteUnit(
  $input: DeleteUnitInput!
  $condition: ModelUnitConditionInput
) {
  deleteUnit(input: $input, condition: $condition) {
    id
    status
    name
    rent
    price
    numBedroom
    numBathroom
    buildingID
    userID
    ownerID
    ownerType
    description
    availabilityDate
    actualRentPaymentDate
    activeLeaseID
    type
    unitPlanID
    size
    street
    deposit
    additionalFees
    feesDescription
    tenantID
    contact
    inUnitLaundry
    dishwasher
    airConditioning
    furnished
    balcony
    petFriendly
    shortTermStayEnabled
    forSaleEnabled
    stayRequireApproval
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUnitMutationVariables,
  APITypes.DeleteUnitMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    authUID
    username
    title
    type
    firstName
    middleName
    lastName
    salary
    companyName
    phoneNumber
    email
    officeAddress
    workingHours
    roles
    organizationID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    authUID
    username
    title
    type
    firstName
    middleName
    lastName
    salary
    companyName
    phoneNumber
    email
    officeAddress
    workingHours
    roles
    organizationID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    authUID
    username
    title
    type
    firstName
    middleName
    lastName
    salary
    companyName
    phoneNumber
    email
    officeAddress
    workingHours
    roles
    organizationID
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createUserOrganizationConnection = /* GraphQL */ `mutation CreateUserOrganizationConnection(
  $input: CreateUserOrganizationConnectionInput!
  $condition: ModelUserOrganizationConnectionConditionInput
) {
  createUserOrganizationConnection(input: $input, condition: $condition) {
    id
    userID
    username
    creatorID
    creatorName
    organizationID
    managerID
    managerName
    title
    salary
    ownershipType
    clearanceLevel
    joinedDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserOrganizationConnectionMutationVariables,
  APITypes.CreateUserOrganizationConnectionMutation
>;
export const updateUserOrganizationConnection = /* GraphQL */ `mutation UpdateUserOrganizationConnection(
  $input: UpdateUserOrganizationConnectionInput!
  $condition: ModelUserOrganizationConnectionConditionInput
) {
  updateUserOrganizationConnection(input: $input, condition: $condition) {
    id
    userID
    username
    creatorID
    creatorName
    organizationID
    managerID
    managerName
    title
    salary
    ownershipType
    clearanceLevel
    joinedDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserOrganizationConnectionMutationVariables,
  APITypes.UpdateUserOrganizationConnectionMutation
>;
export const deleteUserOrganizationConnection = /* GraphQL */ `mutation DeleteUserOrganizationConnection(
  $input: DeleteUserOrganizationConnectionInput!
  $condition: ModelUserOrganizationConnectionConditionInput
) {
  deleteUserOrganizationConnection(input: $input, condition: $condition) {
    id
    userID
    username
    creatorID
    creatorName
    organizationID
    managerID
    managerName
    title
    salary
    ownershipType
    clearanceLevel
    joinedDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserOrganizationConnectionMutationVariables,
  APITypes.DeleteUserOrganizationConnectionMutation
>;
export const createYearlyReportSummary = /* GraphQL */ `mutation CreateYearlyReportSummary(
  $input: CreateYearlyReportSummaryInput!
  $condition: ModelYearlyReportSummaryConditionInput
) {
  createYearlyReportSummary(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    year
    entityID
    entityType
    income {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateYearlyReportSummaryMutationVariables,
  APITypes.CreateYearlyReportSummaryMutation
>;
export const updateYearlyReportSummary = /* GraphQL */ `mutation UpdateYearlyReportSummary(
  $input: UpdateYearlyReportSummaryInput!
  $condition: ModelYearlyReportSummaryConditionInput
) {
  updateYearlyReportSummary(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    year
    entityID
    entityType
    income {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateYearlyReportSummaryMutationVariables,
  APITypes.UpdateYearlyReportSummaryMutation
>;
export const deleteYearlyReportSummary = /* GraphQL */ `mutation DeleteYearlyReportSummary(
  $input: DeleteYearlyReportSummaryInput!
  $condition: ModelYearlyReportSummaryConditionInput
) {
  deleteYearlyReportSummary(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    year
    entityID
    entityType
    income {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteYearlyReportSummaryMutationVariables,
  APITypes.DeleteYearlyReportSummaryMutation
>;
export const createYearlyStatusSummary = /* GraphQL */ `mutation CreateYearlyStatusSummary(
  $input: CreateYearlyStatusSummaryInput!
  $condition: ModelYearlyStatusSummaryConditionInput
) {
  createYearlyStatusSummary(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    entityID
    entityType
    year
    numOccupied
    numVacant
    numRenovation
    numUnits
    numBuildings
    numProperties
    numServiceRequests
    numAmenities
    numAmenityReservations
    expectedRent
    expectedStayRevenue
    aggregateIncome {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateYearlyStatusSummaryMutationVariables,
  APITypes.CreateYearlyStatusSummaryMutation
>;
export const updateYearlyStatusSummary = /* GraphQL */ `mutation UpdateYearlyStatusSummary(
  $input: UpdateYearlyStatusSummaryInput!
  $condition: ModelYearlyStatusSummaryConditionInput
) {
  updateYearlyStatusSummary(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    entityID
    entityType
    year
    numOccupied
    numVacant
    numRenovation
    numUnits
    numBuildings
    numProperties
    numServiceRequests
    numAmenities
    numAmenityReservations
    expectedRent
    expectedStayRevenue
    aggregateIncome {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateYearlyStatusSummaryMutationVariables,
  APITypes.UpdateYearlyStatusSummaryMutation
>;
export const deleteYearlyStatusSummary = /* GraphQL */ `mutation DeleteYearlyStatusSummary(
  $input: DeleteYearlyStatusSummaryInput!
  $condition: ModelYearlyStatusSummaryConditionInput
) {
  deleteYearlyStatusSummary(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    entityID
    entityType
    year
    numOccupied
    numVacant
    numRenovation
    numUnits
    numBuildings
    numProperties
    numServiceRequests
    numAmenities
    numAmenityReservations
    expectedRent
    expectedStayRevenue
    aggregateIncome {
      rentRevenue
      stayRevenue
      feeRevenue
      otherRevenue
      totalRevenue
      repairExpenses
      lostRentExpenses
      renovationExpenses
      totalExpenses
      net
      userID
      ownerID
      ownerType
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteYearlyStatusSummaryMutationVariables,
  APITypes.DeleteYearlyStatusSummaryMutation
>;
export const createYearRecords = /* GraphQL */ `mutation CreateYearRecords(
  $input: CreateYearRecordsInput!
  $condition: ModelYearRecordsConditionInput
) {
  createYearRecords(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    years
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateYearRecordsMutationVariables,
  APITypes.CreateYearRecordsMutation
>;
export const updateYearRecords = /* GraphQL */ `mutation UpdateYearRecords(
  $input: UpdateYearRecordsInput!
  $condition: ModelYearRecordsConditionInput
) {
  updateYearRecords(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    years
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateYearRecordsMutationVariables,
  APITypes.UpdateYearRecordsMutation
>;
export const deleteYearRecords = /* GraphQL */ `mutation DeleteYearRecords(
  $input: DeleteYearRecordsInput!
  $condition: ModelYearRecordsConditionInput
) {
  deleteYearRecords(input: $input, condition: $condition) {
    id
    userID
    ownerID
    ownerType
    years
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteYearRecordsMutationVariables,
  APITypes.DeleteYearRecordsMutation
>;
